module.exports = __webpack_public_path__ + "img/gobackXG.44b7ba5e.png";